'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
const KeyboardUtil = require('../../util/keyboard');
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const ActivityActions = require('../../actions/ActivityActions');
const ActivityStore = require('../../stores/activity_store_reflux');
const ProjectActions = require('../../actions/ProjectActions');
const ProjectStore = require('../../stores/ProjectStore');
const ForgeError = require('../../util/error');
import ErrorBox from '../common/ErrorBox';
import TagEditorTable from '../Tags/TagEditorTable';
import TagTable from '../Tags/TagTable';
import TagHelp from '../Tags/TagHelp';
import WithOrganizationIntegrationTags from '../DataHOCs/WithOrganizationIntegrationTags';

const propTypes = {
    closeHandler: PropTypes.func.isRequired,
    show: PropTypes.bool,
    activityId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    orgId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

const defaultProps = {
    show: false
};

class ManageActivityTagsModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            addActionId: null,
            activityStoreState: ActivityStore.getState(),
            projectStoreState: ProjectStore.getState(),
        };

        this.onNewTagsAdd = this.onNewTagsAdd.bind(this);
        this.onDeleteTag = this.onDeleteTag.bind(this);

        this.unsubscribes = [
            ActivityStore.listen(this.onActivityStoreChange.bind(this)),
            ProjectStore.listen(this.onProjectStoreChange.bind(this)),
        ];
    }

    componentDidMount() {
        // if (!this.state.activityStoreState.activityTags[this.props.activityId]) {} //Load only if never received?
        ActivityActions.getActivityTags(uuid.v4(), { activityId: this.props.activityId });
        ProjectActions.getProjectTags(uuid.v4(), { projectID: this.props.projectId });
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onActivityStoreChange(newState) {
        let additionalState = {};

        if (newState.action.id === this.state.addActionId) {
            if (!newState.action.error) {
                additionalState = { ...additionalState, addActionId: null, error: null, newTag: '' };

            }
            else {
                additionalState = { ...additionalState, addActionId: null, error: newState.action.error };
            }
        }

        this.setState({ activityStoreState: newState, ...additionalState });
    }

    onProjectStoreChange(newState) {
        this.setState({ projectStoreState: newState });
    }

    onNewTagsAdd(tagRecords) {
        if (!tagRecords) {
            this.setState({ error: new ForgeError({ message: 'The tag field cannot be blank' }) });
            return;
        }

        const actionId = uuid.v4();
        this.setState({ addActionId: actionId }, () => {
            ActivityActions.addActivityTags(actionId, { activityId: this.props.activityId, tagRecords: tagRecords });
        });
    }

    onDeleteTag(tagRecord) {
        ActivityActions.deleteActivityTag(uuid.v4(), { activityId: this.props.activityId, tagRecord: tagRecord });
    }

    getActiveTagExportHref() {
        return `/authoring/activity/${this.props.activityId}/tag_v2/csv`;
    }

    render() {
        const self = this;
        const activityTags = this.state.activityStoreState.activityTags[this.props.activityId] || [];
        const projectTags = this.state.projectStoreState.projectTags[this.props.projectId] || [];
        const duplicateTagsIds = [];
        activityTags.forEach((actTag) => {
            if (projectTags.find(pTag => pTag.id === actTag.id)) duplicateTagsIds.push(actTag.id);
        });

        return (
            <Modal
                className='single-input-modal'
                show={this.props.show}
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>manage activity integration tags</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ErrorBox error={this.state.error}/>
                    <TagEditorTable
                        className="padding-lr-md margin-bottom-xl"
                        orgIntegrationTags={this.props.orgIntegrationTags}
                        forceRefresh
                        tags={activityTags}
                        onDeleteTag={this.onDeleteTag}
                        onNewTagsAdd={this.onNewTagsAdd}
                        pendingAddNewTag={!!this.state.addActionId}
                        activeTagExportHref={this.getActiveTagExportHref()}
                        duplicateTagsIds={duplicateTagsIds}
                        duplicateTooltipMessage={Strings['en'].tag.ALSO_ACTIVE_PROJECT}
                    />
                    <div className="margin-bottom-md">
                        <div className="termListing">
                            <h2 className="termListing__termContainer font-weight-bold">
                                Project Tags (Read-Only)
                            </h2>
                        </div>
                    </div>
                    <TagTable
                        className="margin-bottom-xl"
                        orgIntegrationTags={this.props.orgIntegrationTags}
                        tags={projectTags}
                    />
                    <TagHelp className="padding-all-md" />
                </Modal.Body>
            </Modal>
        );
    }
}

ManageActivityTagsModal.propTypes = propTypes;
ManageActivityTagsModal.defaultProps = defaultProps;

export default WithOrganizationIntegrationTags(ManageActivityTagsModal);